export default __webpack_public_path__ + "static/media/torus.fadfad62.svg";